import {
  AfterViewChecked,
  Component,
  OnChanges,
  signal,
  SimpleChanges
} from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { CONSTVersion } from '@constant/const-version';
import { BaseComponent } from '@library-shared/base/base.component';
import { BaseService, BaseServiceOptions } from '@library-shared/base/base.service';
import { vSession } from '@models/Views/vSession';
import { SearchComponent } from '@search/search.component';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { SiteService } from '@services/site/site.service';
import { MaintenanceComponent } from '@system/maintenance/maintenance.component';
import config from 'devextreme/core/config';
import { CookieService } from 'ngx-cookie-service';
import { devextreme_licenseKey } from 'src/devextreme-license';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends BaseComponent implements AfterViewChecked, OnChanges {
  title = 'Paysite';
  screenNumber = '';
  versionNumber = signal(CONSTVersion.version);

  /*

     favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  changeIcon() {
    this.favIcon.href = 'https://www.google.com/favicon.ico';
  }
  */

  hookPerformance = true;

  modeBanner = '';
  modeName = '';
  showFolderSelect = false;
  currentYear = new Date().getFullYear() - 2000;
  minutesLeft = 30;

  pageName = 'Paysite';
  authenticatedSession: vSession = new vSession();

  navOpen = false;
  loggedOut = true;

  serviceOptions: BaseServiceOptions = {
    loggedOutMessage: 'Your session has expired',
    loginURL: '/search',
    logoutURL: '/search',
    resetURL: '/search',
    resetPathList: ['search'],
    useReturnURL: false,
  };

  constructor(
    private cookies: CookieService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private siteService: SiteService,
  ) {
    super();
    config({
      licenseKey: devextreme_licenseKey,
    });

    this.router.events.subscribe((e) => this.handleRouterEvents(e));
    BaseService.options(this.serviceOptions);
    this.authenticationService.AuthenticatedSession().subscribe({
      next: (data) => {
        this.updateSessionTimer();
      },
    });
    setInterval(() => {
      this.authenticationService.AuthenticatedSession().subscribe({
        next: (data) => {
          if (data.success) {
            this.updateSessionTimer();
          } else {
            if (
              !window.location.href.includes('/search') &&
              !window.location.href.includes('/receipt') &&
              !window.location.href.includes('/maintenance')
            ) {
              this.router.navigate([BaseService.serviceOptions.loginURL]);
              this.toast_warn({ message: BaseService.serviceOptions.loggedOutMessage });
            }
          }
        },
      });
    }, 1000 * 60);
  }

  ngAfterViewChecked() {}

  ngOnChanges(changes: SimpleChanges) {
    this.log.info('change', changes);
  }

  handleRouterEvents(events: any) {
    // this.log.data('handleRouterEvents', events);
    if (events instanceof ActivationEnd) {
      const e: ActivationEnd = events;
      if (e.snapshot.component === SearchComponent || e.snapshot.component == MaintenanceComponent) {
        this.minutesLeft = 0;
      } else {
        this.updateSessionTimer();
      }
    }
  }

  updateSessionTimer = () => {
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        if (data.success) {
          if (data.record.is_in_site_maintenance) {
            this.router.navigateByUrl('/maintenance');
            return;
          }

          this.SessionCheck();
        }
      },
    });
  };

  private SessionCheck() {
    const min = +this.cookies.get('MinutesLeft');
    this.minutesLeft = Math.trunc(min);
    if (window.location.href.includes('/search')) {
      if (this.minutesLeft < 25) {
        // renew session if < 5 minutes left
        this.authenticationService.Session_Refresh().subscribe();
      }
      this.minutesLeft = 0;
    }
  }
}
